import type { AsyncSequence } from "../types/AsyncSequence"
import { ArrayToIterable } from "./ArrayToIterable"

export async function* MapAsync<T, N>(
  func: (item: T, index: number) => N | Promise<N>,
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<N> {
  let index = 0
  for await (const item of ArrayToIterable(...arrays)) {
    yield await func(item, index++)
  }
}
